import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function TermsPage() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const articles = [
    {
      title: '第1条（適用）',
      content: [
        'PawBridge（以下「当社」といいます）が提供するペットシッティング仲介サービス（以下「本サービス」）の利用条件を定めるものです。',
      ],
    },
    {
      title: '第2条（サービス内容）',
      content: [
        '本サービスは、ペットの飼い主とペットシッターをマッチングするプラットフォームを提供するものであり、ペットシッティングサービスそのものを提供するものではありません。',
      ],
    },
    {
      title: '第3条（当社の立場）',
      content: [
        '当社は仲介事業者であり、実際のペットシッティング契約は飼い主とシッターの間で直接成立します。当社はサービス提供の当事者ではありません。',
      ],
    },
    {
      title: '第4条（利用登録）',
      content: [
        '利用者は、正確かつ最新の情報を提供し、自己の責任においてアカウントを管理するものとします。',
      ],
    },
    {
      title: '第5条（予約および支払い）',
      content: [],
      list: [
        'すべての予約および支払いは本サービスを通じて行うものとします。',
        'プラットフォーム外での直接取引は禁止します。',
      ],
    },
    {
      title: '第6条（料金）',
      content: [
        '利用者は、表示されたサービス料金および当社が定める手数料を含む総額を支払うものとします。',
      ],
    },
    {
      title: '第7条（キャンセル）',
      content: [
        'キャンセルポリシーは各シッターにより定められます。利用者は予約時に内容を確認するものとします。',
      ],
    },
    {
      title: '第8条（禁止事項）',
      content: ['利用者は以下の行為を行ってはなりません。'],
      bullets: [
        '虚偽情報の登録',
        '危険な動物の預託',
        '違法行為または公序良俗に反する行為',
        '本サービスを通さない直接取引の誘導',
      ],
    },
    {
      title: '第9条（責任）',
      content: [
        'ペットの管理および安全確保は、飼い主およびシッター双方の責任とします。',
      ],
    },
    {
      title: '第10条（免責）',
      content: [
        '当社は、シッターおよび飼い主間のトラブルについて責任を負いません。ただし、当社の故意または重大な過失による場合を除きます。',
      ],
    },
    {
      title: '第11条（保証制度）',
      content: ['本サービスには、別途定める「安心保証規約」が適用されます。'],
      linkTo: '/guarantee',
      linkLabel: '安心保証規約を確認する →',
    },
    {
      title: '第12条（アカウント停止）',
      content: [
        '当社は、利用者が本規約に違反した場合、事前通知なくアカウントを停止または削除できるものとします。',
      ],
    },
    {
      title: '第13条（規約の変更）',
      content: [
        '当社は必要に応じて本規約を変更することができます。',
      ],
    },
    {
      title: '第14条（準拠法および管轄）',
      content: [
        '本規約はオランダ法に準拠し、紛争は当社所在地を管轄する裁判所を第一審の専属管轄とします。',
      ],
    },
  ] as const;

  return (
    <div className="min-h-screen bg-[#EEF4F7]">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#81D8D0]/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-24 sm:h-28">
            <Link to="/" className="flex items-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="w-40 h-40 sm:w-48 sm:h-48 object-contain brightness-0"
              />
            </Link>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-8">
              <Link to="/sitters" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                シッターを探す
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/sitter-registration" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                シッター登録
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/login" className="relative text-sm text-white hover:text-white transition-colors whitespace-nowrap group">
                ログイン
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-white rounded-full transition-all duration-300 group-hover:w-full"></span>
              </Link>
              <Link to="/booking" className="px-6 py-2.5 bg-white text-[#81D8D0] text-sm font-medium rounded-full hover:bg-white/90 transition-all hover:shadow-lg whitespace-nowrap">
                予約する
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 space-y-3">
              <Link to="/sitters" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">シッターを探す</Link>
              <Link to="/sitter-registration" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">シッター登録</Link>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)} className="block text-sm text-white hover:text-white/80 transition-colors py-2">ログイン</Link>
              <Link to="/booking" onClick={() => setMobileMenuOpen(false)} className="block px-6 py-2.5 bg-white text-[#81D8D0] text-sm font-medium rounded-full hover:bg-white/90 transition-all text-center">予約する</Link>
            </div>
          )}
        </div>
      </nav>

      <div className="pt-28 sm:pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          {/* Header */}
          <div className="mb-8 md:mb-12">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#81D8D0]/20">
                <i className="ri-file-list-3-line text-xl text-[#81D8D0]"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-[#1B2A4A]">PawBridge 利用規約</h1>
            </div>
            <p className="text-xs md:text-sm text-[#1B2A4A]/50">最終更新日：2026年3月29日 ／ 準拠法：オランダ法</p>
          </div>

          {/* Quick summary cards */}
          <div className="grid sm:grid-cols-3 gap-4 mb-8">
            {[
              { icon: 'ri-swap-line', label: 'マッチング仲介', sub: '当社はサービス提供の当事者ではありません' },
              { icon: 'ri-lock-line', label: 'プラットフォーム内取引必須', sub: 'プラットフォーム外の直接取引は禁止です' },
              { icon: 'ri-shield-check-line', label: '安心保証付き', sub: '別途「安心保証規約」が適用されます' },
            ].map(card => (
              <div key={card.label} className="bg-[#81D8D0]/10 border border-[#81D8D0]/30 rounded-xl p-4 flex gap-3 items-start">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#81D8D0]/20 flex-shrink-0">
                  <i className={`${card.icon} text-lg text-[#81D8D0]`}></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-[#1B2A4A]">{card.label}</p>
                  <p className="text-xs text-[#1B2A4A]/60 leading-relaxed mt-0.5">{card.sub}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Articles */}
          <div className="bg-white rounded-2xl p-4 md:p-8 shadow-sm space-y-6 md:space-y-8">
            {articles.map((article, i) => (
              <section key={i} className={i > 0 ? 'border-t border-[#D4E8EC] pt-6 md:pt-8' : ''}>
                <h2 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-3 md:mb-4">{article.title}</h2>
                <div className="space-y-2 md:space-y-3 text-sm md:text-base text-[#1B2A4A]/80 leading-relaxed">
                  {article.content.map((p, j) => <p key={j}>{p}</p>)}
                  {'list' in article && article.list && (
                    <ol className="list-decimal list-inside space-y-1.5 md:space-y-2 ml-2 md:ml-4">
                      {article.list.map((item, j) => <li key={j}>{item}</li>)}
                    </ol>
                  )}
                  {'bullets' in article && article.bullets && (
                    <ul className="list-disc list-inside space-y-1.5 md:space-y-2 ml-2 md:ml-4">
                      {article.bullets.map((item, j) => <li key={j}>{item}</li>)}
                    </ul>
                  )}
                  {'linkTo' in article && article.linkTo && (
                    <div className="mt-3">
                      <Link
                        to={article.linkTo}
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-[#81D8D0] hover:text-[#5fc4bc] transition-colors cursor-pointer"
                      >
                        <i className="ri-shield-check-line"></i>
                        {article.linkLabel}
                      </Link>
                    </div>
                  )}
                </div>
              </section>
            ))}

            {/* Platform outside trade warning */}
            <section className="border-t border-[#D4E8EC] pt-6 md:pt-8">
              <div className="bg-red-50 border border-red-200 rounded-xl p-4 md:p-5">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-error-warning-line text-red-500 text-lg"></i>
                  <p className="text-sm font-bold text-red-700">プラットフォーム外取引の禁止について</p>
                </div>
                <p className="text-xs md:text-sm text-red-700/80 leading-relaxed mb-3">
                  当サービスを通じて知り合ったシッター・飼い主との取引は、必ずプラットフォーム内で完結させてください。以下の行為は厳重に禁止されています。
                </p>
                <ul className="text-xs md:text-sm text-red-700/80 space-y-1.5 list-disc list-inside ml-1">
                  <li>電話番号・LINE・WhatsApp 等の外部連絡先の交換</li>
                  <li>プラットフォーム外での直接契約・決済</li>
                  <li>本サービスを介さない継続的な取引関係の構築</li>
                </ul>
                <p className="text-xs text-red-600 font-semibold mt-3">違反が発覚した場合、アカウントの停止・削除および法的措置を含む厳正な対処を行います。</p>
              </div>
            </section>

            {/* Cancel policy summary */}
            <section className="border-t border-[#D4E8EC] pt-6 md:pt-8">
              <h2 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-3 md:mb-4">キャンセルポリシー（概要）</h2>
              <p className="text-sm md:text-base text-[#1B2A4A]/80 leading-relaxed mb-5">
                ご予約のキャンセルは以下のポリシーに従って処理されます。
              </p>
              <div className="grid sm:grid-cols-2 gap-4 mb-5">
                {[
                  { icon: 'ri-check-circle-line', iconColor: 'text-emerald-500', bg: 'bg-emerald-50', border: 'border-emerald-200', title: '予約日の48時間前まで', detail: '無料でキャンセル可能', sub: 'お支払い済みの場合は全額返金いたします。' },
                  { icon: 'ri-error-warning-line', iconColor: 'text-amber-500', bg: 'bg-amber-50', border: 'border-amber-200', title: '予約日の24時間以内', detail: 'お支払い額の50%を請求', sub: '残り50%は返金いたします。' },
                  { icon: 'ri-close-circle-line', iconColor: 'text-red-500', bg: 'bg-red-50', border: 'border-red-200', title: '無断キャンセル（ノーショー）', detail: 'お支払い額の100%を請求', sub: '事前連絡なしにサービスをご利用されなかった場合。' },
                  { icon: 'ri-user-received-line', iconColor: 'text-[#81D8D0]', bg: 'bg-[#EEF4F7]', border: 'border-[#D4E8EC]', title: 'シッター都合のキャンセル', detail: '全額返金', sub: 'シッター側の事情によるキャンセルの場合。' },
                ].map(item => (
                  <div key={item.title} className={`rounded-xl border ${item.border} ${item.bg} p-4`}>
                    <div className="flex items-center gap-2 mb-2">
                      <i className={`${item.icon} text-xl ${item.iconColor}`}></i>
                      <p className="text-sm font-bold text-[#1B2A4A]">{item.title}</p>
                    </div>
                    <p className={`text-base font-black mb-1 ${item.iconColor}`}>{item.detail}</p>
                    <p className="text-xs text-[#1B2A4A]/60 leading-relaxed">{item.sub}</p>
                  </div>
                ))}
              </div>
              <div className="bg-[#EEF4F7] rounded-xl p-4 space-y-2">
                <p className="text-xs font-bold text-[#1B2A4A] mb-2 flex items-center gap-1.5">
                  <i className="ri-information-line text-[#81D8D0]"></i>
                  注意事項
                </p>
                <ul className="text-xs text-[#1B2A4A]/70 space-y-1.5 leading-relaxed list-disc list-inside ml-1">
                  <li>キャンセル料は、確定済みの予約（シッター承認・お支払い完了後）にのみ適用されます。</li>
                  <li>リクエスト段階（シッター未承認・未払い）のキャンセルは、いかなる場合も無料です。</li>
                  <li>返金は、元のお支払い方法に対して7営業日以内に処理されます。</li>
                  <li>天災・緊急事態など不可抗力によるキャンセルは、別途ご相談ください。</li>
                </ul>
              </div>
            </section>

            {/* Contact */}
            <section className="border-t border-[#D4E8EC] pt-6 md:pt-8">
              <h2 className="text-xl md:text-2xl font-bold text-[#1B2A4A] mb-3 md:mb-4">お問い合わせ</h2>
              <p className="text-sm md:text-base text-[#1B2A4A]/80 leading-relaxed">
                本規約に関するお問い合わせは、本サービス内のお問い合わせフォームからご連絡ください。
              </p>
            </section>
          </div>

          <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              <i className="ri-arrow-left-line"></i>
              ホームに戻る
            </Link>
            <span className="hidden sm:block text-[#1B2A4A]/30">|</span>
            <Link to="/sitter-terms" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              シッター利用規約を見る
              <i className="ri-arrow-right-line"></i>
            </Link>
            <span className="hidden sm:block text-[#1B2A4A]/30">|</span>
            <Link to="/guarantee" className="inline-flex items-center gap-2 text-xs md:text-sm text-[#1B2A4A]/60 hover:text-[#1B2A4A] transition-colors cursor-pointer">
              安心保証規約を見る
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-[#81D8D0] text-white pt-12 md:pt-20 pb-8 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <img
                src="https://static.readdy.ai/image/8518bd20f704ac7d2f3f65f4644eeb9a/37cbdfbab98dc394d9ee285d8ad1648c.svg"
                alt="PawBridge"
                className="h-28 md:h-36 mb-4 md:mb-5 brightness-0"
              />
              <p className="text-xs md:text-sm text-white/80 leading-relaxed">海外在住日本人のためのペットシッターコミュニティ</p>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">サービス</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/sitters" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター検索</Link></li>
                <li><Link to="/sitter-registration" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">シッター登録</Link></li>
                <li><Link to="/booking" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">料金</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-xs md:text-sm font-semibold uppercase mb-4 md:mb-6">会社情報</h4>
              <ul className="space-y-3 md:space-y-4">
                <li><Link to="/about" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridgeについて</Link></li>
                <li><Link to="/contact" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">お問い合わせ</Link></li>
                <li><Link to="/terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 利用規約</Link></li>
                <li><Link to="/sitter-terms" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge シッター利用規約</Link></li>
                <li><Link to="/guarantee" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">PawBridge 安心保証規約</Link></li>
                <li><Link to="/privacy" className="text-xs md:text-sm text-white/80 hover:text-white transition-colors">プライバシーポリシー</Link></li>
              </ul>
            </div>
          </div>
          <div className="pt-6 md:pt-8 border-t border-white/30 text-center">
            <p className="text-xs text-white/70">© 2025 PawBridge. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
